import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AddItemSuccessInterface {
  addItemSuccess: boolean;
}

const initialState: AddItemSuccessInterface = {
  addItemSuccess: false,
};

const addItemSuccessSlice = createSlice({
  name: "boardName",
  initialState,
  reducers: {
    setAddItemSuccess: (state, action: PayloadAction<boolean>) => {
      state.addItemSuccess = action.payload;
    },
  },
});

export const { setAddItemSuccess } = addItemSuccessSlice.actions;
export default addItemSuccessSlice.reducer;
